import Entity from 'lib/Entity';

class ChatSender extends Entity {
  getName(): string {
    return this.get('name');
  }

  getColor() {
    return this.get('color');
  }

  getUuid(): string {
    return this.get('uuid');
  }

  getInitials(): string {
    return this.get('initials');
  }

  isCurrentUser(): boolean {
    // XXX remove CurrentUser from entities
    const CurrentUser = require('auth/CurrentUser').default;

    if (!CurrentUser.isSignedIn()) {
      return false;
    }

    return this.id === CurrentUser.getUserId();
  }
}

export default ChatSender;
